<skill-table>

    <div class="flex flex-col md:flex-row gap-4 mb-4 md:items-center" if="{state.showSearch}">
        <div class="w-full md:flex-1">
            <div class="relative w-full">
                <input id="skill-table-search" type="text" placeholder="{locale?.t('search')}" aria-label="{locale?.t('search')}" class="input w-full ps-10 bg-white focus:outline-none focus:ring-0 placeholder:font-bold" value="{state.searchTerm}" oninput="{updateSearchTerm}"/>
                <span class="absolute inset-y-0 start-0 flex items-center ps-3 text-gray-500 text-xl z-20">
                    <i class="icon-search1"></i>
                </span>
            </div>
        </div>
        <div class="md:flex-none flex flex-row gap-2 items-center" if="{!props.originfilterhidden}">
            <label class="font-bold text-xs" for="skill-table-origin-filter">{locale?.t('skilltable_origin')}:</label>
            <select id="skill-table-origin-filter" value="{state.originFilter}" onchange="{updateOriginFilter}"
                    class="select bg-white focus:outline-none focus:ring-0 whitespace-nowrap lg:min-w-32 font-medium">
                <option value="all" selected="{state.originFilter === 'all'}">{locale?.t('skilltable_origin_all')}</option>
                <option each="{option in originOptions()}" value="{option.key}"
                        selected="{state.originFilter === option.key}">{option.label}</option>
            </select>
        </div>
        <div class="w-full md:w-1/4">
            <button type="button" class="btn btn-md btn-primary rounded-lg w-full uppercase"
                    onclick="{openExportModal}"><i class="icon-metalark-export"></i> {locale?.t(props.exportlabelkey || 'skilltable_exportskillsdata')}</button>
        </div>
    </div>

    <div class="flex flex-row gap-6 justify-end mb-2 content-table-top-row items-center">
        <span class="text-sm text-primary font-semibold" if="{props.showtotal && state.total}">{locale?.t('total')}: {formatNumber(state.total)}</span>
        <span class="text-sm text-primary font-semibold" if="{props.showtimestamp && state.timestamp}">{formatDateTime(state.timestamp)}</span>
        <button type="button" onclick="{generatePrintView}" if="{props.showprint && state.total}"
                class="btn btn-sm btn-primary print:hidden"
                title="{locale?.t('printresults')}">
            <i class="icon-printer me-1"></i> {locale?.t('print')}
        </button>
    </div>

    <div class="overflow-hidden border border-1 border-base-300 rounded-md">
        <div class="overflow-x-auto">
            <table class="table">
                <thead>
                <tr class="text-accent border-b border-base-300">
                    <th class="px-3 py-2 text-white bg-primary font-semibold max-w-xs {state.showSort ? 'cursor-pointer' : ''}"
                        tabindex="0"
                        aria-sort="{getAriaSort('alpha')}"
                        onclick="{toggleNameSort}"
                        onkeydown="{tools?.keyClick(toggleNameSort)}">
                        <div class="flex flex-row items-center gap-2">
                            {locale?.t('skillname')}

                            <div class="flex flex-col text-white align-middle items-center sort-arrows" if="{state.showSort}">
                                <i class="icon-metalark-arrow-up {state.sortOption === 'alpha-desc' ? '' : 'opacity-50'}"></i>
                                <i class="icon-metalark-arrow-down {state.sortOption === 'alpha-asc' ? '' : 'opacity-50'}"></i>
                            </div>
                        </div>
                    </th>
                    <th class="px-3 py-2 text-white bg-primary font-semibold max-w-lg">{locale?.t('description')}</th>
                    <th class="px-3 py-2 text-white bg-primary font-semibold {state.showSort ? 'cursor-pointer' : ''}"
                        tabindex="0"
                        aria-sort="{getAriaSort('origin')}"
                        onclick="{toggleOriginSort}"
                        onkeydown="{tools?.keyClick(toggleOriginSort)}">
                        <div class="flex flex-row items-center gap-2">
                            {locale?.t('origin')}

                            <div class="flex flex-col text-white align-middle items-center sort-arrows" if="{state.showSort}">
                                <i class="icon-metalark-arrow-up {state.sortOption === 'origin-desc' ? '' : 'opacity-50'}"></i>
                                <i class="icon-metalark-arrow-down {state.sortOption === 'origin-asc' ? '' : 'opacity-50'}"></i>
                            </div>
                        </div>
                    </th>
                    <th class="px-3 py-2 text-white bg-primary font-semibold">{locale?.t('itemcount')}</th>
                    <th class="px-3 py-2 text-white bg-primary font-semibold {state.showSort ? 'cursor-pointer' : ''}"
                        tabindex="0"
                        aria-sort="{getAriaSort('date')}"
                        onclick="{toggleDateSort}"
                        onkeydown="{tools?.keyClick(toggleDateSort)}"
                        if="{props.showdates}">
                        <div class="flex flex-row items-center gap-2">
                            {locale?.t('tagtable_createddate')}

                            <div class="flex flex-col text-white align-middle items-center sort-arrows" if="{state.showSort}">
                                <i class="icon-metalark-arrow-up {state.sortOption === 'date-desc' ? '' : 'opacity-50'}"></i>
                                <i class="icon-metalark-arrow-down {state.sortOption === 'date-asc' ? '' : 'opacity-50'}"></i>
                            </div>
                        </div>
                    </th>
                    <th class="px-3 py-2 text-white bg-primary font-semibold {state.showSort ? 'cursor-pointer' : ''}"
                        tabindex="0"
                        aria-sort="{getAriaSort('updated')}"
                        onclick="{toggleUpdatedDateSort}"
                        onkeydown="{tools?.keyClick(toggleUpdatedDateSort)}"
                        if="{props.showdates}">
                        <div class="flex flex-row items-center gap-2">
                            {locale?.t('tagtable_updateddate')}

                            <div class="flex flex-col text-white align-middle items-center sort-arrows" if="{state.showSort}">
                                <i class="icon-metalark-arrow-up {state.sortOption === 'updated-desc' ? '' : 'opacity-50'}"></i>
                                <i class="icon-metalark-arrow-down {state.sortOption === 'updated-asc' ? '' : 'opacity-50'}"></i>
                            </div>
                        </div>
                    </th>
                    <th class="px-3 py-2 text-white bg-primary font-semibold" if="{props.showactions}">{locale?.t('actions')}</th>
                </tr>
                </thead>
                <tbody>

                <!-- Loading skeleton - show 4 rows while loading -->
                <template if="{state.searching}">
                    <template each="{(_, index) in [1, 2, 3, 4]}">
                        <tr class="{index % 2 === 0 ? 'bg-white' : 'bg-base-200'} border-b border-base-300">
                            <td class="px-3 py-4" colspan="100">
                                <div class="flex flex-row gap-4 items-center justify-between">
                                    <div class="skeleton h-4 w-48"></div>
                                    <div class="skeleton h-4 w-64"></div>
                                    <div class="skeleton h-4 w-24"></div>
                                    <div class="skeleton h-4 w-20"></div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </template>

                <tr if="{!(state.skills || []).length && !state.searching && state.hasLoaded}" class="text-center bg-white">
                    <td class="px-3 py-4" colspan="100" if="{!state.searching || props.preventsearchwithoutfilters}">
                        <slot name="empty">
                            {state.emptyMessage}
                        </slot>
                    </td>
                </tr>

                <tr each="{skill in (state.skills || [])}" key="{skill.skillId}" class="odd:bg-base-200 even:bg-white border-b border-base-300 last:border-b-0" if="{!state.searching}">
                    <td class="px-3 py-4 font-semibold max-w-xs">
                        <a href="#skills/skill?id={skill.skillId}">{skill.displayName}</a>
                    </td>
                    <td class="px-3 py-4 font-medium max-w-lg">
                        <span class="line-clamp-2">
                            {skill.description}
                        </span>
                    </td>
                    <td class="px-3 py-4 font-medium">{tools?.skillOriginDisplay(skill.origin)}</td>
                    <td class="px-3 py-4 font-medium">{tools?.formatNumber(skill.resources?.length || 0)}</td>
                    <td class="px-3 py-4 font-medium" if="{props.showdates}">{tools?.formatDate(skill.createdDate)}</td>
                    <td class="px-3 py-4 font-medium" if="{props.showdates}">{tools?.formatDate(skill.updatedDate)}</td>
                    <td class="px-3 py-4" if="{props.showactions}">
                        <slot name="actions" skill="{skill}"></slot>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

    <template if="{state.totalPages && state.showPagination}">
        <pagination
                pagelength="{state.pageLength}"
                pageindex="{state.pageIndex}"
                totalpages="{state.totalPages}"
                onPageLengthChange="{onPageLengthChange}"
                onPageIndexChange="{onPageIndexChange}">
        </pagination>
    </template>

    <export-metadata-summary-detail-modal entitytitle="{locale?.t(props.exportlabelkey || 'skilltable_exportskillsdata')}" onconfirm="{exportSkillsCSV}"></export-metadata-summary-detail-modal>

    <script>
        import raw from "../components/raw.tag"
        import pagination from "./pagination.tag"
        import exportMetadataSummaryDetailModal from "./export-metadata-summary-detail-modal.tag"
        import {values} from "../services/values";
        import {getSkillService} from "../services/service-loader";
        import { printReport, printReportStrings, htmlToText } from "../services/print-report.js";

        export default {
            values,

            get components() {
                return {
                    raw,
                    pagination,
                    exportMetadataSummaryDetailModal
                };
            },

            props: {
                filter: null,
                sort: null,
                autoload: true,
                showactions: false,
                showdates: false,
                originfilter: 'all',
                originfilterhidden: false
            },

            formatNumber(number) {
                return this.tools?.formatNumber(number) || '';
            },

            formatDate(date) {
                return this.tools?.formatDate(date) || date;
            },

            formatDateTime(datetime) {
                return this.tools?.formatDateTime(datetime) || '';
            },

            state: {
                skills: null,
                emptyMessage: '',
                searching: false,
                hasLoaded: false,
                mode: 'view',

                showPagination: true,
                pageLength: 10,
                pageIndex: 1,
                totalPages: null,
                total: 0,
                timestamp: null,

                searchTerm: "",
                lastSearchTerm: "",
                lastFilter: null,
                sortOption: "alpha-asc",
                showSort: true,
                showSearch: true,
                originFilter: 'all',
                origins: null,
            },

            onBeforeMount() {
                // Parse props synchronously
                if (this.props.query) {
                    this.state.searchTerm = this.props.query;
                }

                if (this.props.sort) {
                    this.state.sortOption = this.props.sort;
                }

                if (this.props.pagelength) {
                    this.state.pageLength = parseInt(this.props.pagelength);
                }

                if (this.props.pagination === false) {
                    this.state.showPagination = false;
                }

                if (this.props.search === false) {
                    this.state.showSearch = false;
                }

                if (this.props.mode) {
                    this.state.mode = this.props.mode;
                }

                if (typeof this.props.originfilter === 'string' && this.props.originfilter) {
                    this.state.originFilter = this.props.originfilter;
                }
            },

            async onMounted() {
                // Set localized empty message
                this.state.emptyMessage = this.locale?.t('skilltable_noskillsfound') || 'No Skills Found';

                if (!this.props.originfilterhidden) {
                    this.getOrigins();
                }

                // Create debounced function
                this.debouncedGetSkills = this.tools.debounce(() => {
                    this.getSkills()
                }, values.debounceTime);

                if (this.props.autoload !== false) {
                    // Only load skills automatically if autoload is not explicitly false
                    // Parent can set autoload=false to prevent initial fetch and manually trigger it
                    this.getSkills();
                }
            },

            onBeforeUpdate() {
                this.checkMode();
            },

            checkMode() {
                if (this.props.mode && this.props.mode !== this.state.mode) {
                    this.state.mode = this.props.mode;
                }
            },

            onPageLengthChange(e) {
                const length = parseInt(e.target.value);
                this.state.pageLength = length;
                this.state.pageIndex = 1;
                this.getSkills();
            },

            onPageIndexChange(newIndex) {
                this.state.selectAll = false;
                this.state.pageIndex = newIndex;
                this.getSkills();
            },

            toggleNameSort() {
                if (this.state.sortOption === 'alpha-asc') this.updateSortOption('alpha-desc');
                else this.updateSortOption('alpha-asc');
            },

            toggleOriginSort() {
                if (this.state.sortOption === 'origin-asc') this.updateSortOption('origin-desc');
                else this.updateSortOption('origin-asc');
            },

            toggleDateSort() {
                if (this.state.sortOption === 'date-asc') this.updateSortOption('date-desc');
                else this.updateSortOption('date-asc');
            },

            toggleUpdatedDateSort() {
                if (this.state.sortOption === 'updated-asc') this.updateSortOption('updated-desc');
                else this.updateSortOption('updated-asc');
            },

            updateSortOption(option) {
                this.state.sortOption = option;
                this.state.pageIndex = 1;
                this.getSkills();
            },

            getAriaSort(field) {
                const option = this.state.sortOption;
                if (!option || !option.startsWith(field + '-')) return 'none';
                return option.endsWith('-asc') ? 'ascending' : 'descending';
            },

            updateSearchTerm(e) {
                this.state.searchTerm = e.target.value;
                this.state.pageIndex = 1;
                this.debouncedGetSkills();
            },

            updateOriginFilter(e) {
                this.state.originFilter = e.target.value;
                this.state.pageIndex = 1;
                this.getSkills();
            },

            // The origins a workspace actually holds (METALARK-1155). 'custom' and
            // 'ESCO' keep their own phrases; a content-provider key is title-cased
            // from the slug, since that population is open-ended.
            async getOrigins() {
                try {
                    const skillService = await getSkillService();
                    const results = await skillService.getOrigins();
                    this.state.origins = (results?.origins || []).map(o => o.key);
                } catch (e) {
                    this.state.origins = null;
                }
                this.update();
            },

            originOptions() {
                if (!this.locale) return [];
                const keys = this.state.origins || ['custom', 'ESCO'];
                return keys.map(key => ({ key, label: this.tools?.skillOriginDisplay(key) || key }));
            },


            getSort() {
                let sort = [
                    {"field": "displayName", "direction": "desc", caseInsensitive: true}
                ];
                if (this.state.sortOption === 'alpha-desc') {
                    sort = [{"field": "displayName", "direction": "desc", caseInsensitive: true}];
                } else if (this.state.sortOption === 'alpha-asc') {
                    sort = [{"field": "displayName", "direction": "asc", caseInsensitive: true}];
                } else if (this.state.sortOption === 'origin-desc') {
                    sort = [{"field": "origin", "direction": "desc", caseInsensitive: true}];
                } else if (this.state.sortOption === 'origin-asc') {
                    sort = [{"field": "origin", "direction": "asc", caseInsensitive: true}];
                } else if (this.state.sortOption === 'date-desc') {
                    sort = [{"field": "createdDate", "direction": "desc"}];
                } else if (this.state.sortOption === 'date-asc') {
                    sort = [{"field": "createdDate", "direction": "asc"}];
                } else if (this.state.sortOption === 'updated-desc') {
                    sort = [{"field": "updatedDate", "direction": "desc"}];
                } else if (this.state.sortOption === 'updated-asc') {
                    sort = [{"field": "updatedDate", "direction": "asc"}];
                }
                return sort;
            },

            async getSkills() {

                this.state.lastSearchTerm = "";
                this.state.lastFilter = null;
                this.state.searching = true;
                this.update();

                let filter = this.props.filter ? JSON.parse(JSON.stringify(this.props.filter)) : {};

                filter = Object.assign(filter, {
                    $sort: this.getSort()
                });

                const searchTerm = this.state.searchTerm;
                this.state.lastSearchTerm = searchTerm;

                if (searchTerm) {
                    filter.displayName = { $icontains: searchTerm }
                }

                // Origin filter (All / Custom / Standard). Only apply when the
                // parent hasn't already set an `origin` clause via props.filter
                // — that lets the parent fully override if needed.
                if (filter.origin === undefined && this.state.originFilter !== 'all') {
                    filter.origin = this.state.originFilter;
                }

                // Check if search should be prevented without filters
                const filterKeysWithoutSort = Object.keys(filter).filter(key => key !== '$sort');
                if (this.props.preventsearchwithoutfilters && !filterKeysWithoutSort.length && !searchTerm) {
                    this.state.skills = [];
                    this.state.totalPages = 1;
                    this.state.searching = false;
                    this.state.hasLoaded = true;
                    this.state.total = 0;
                    this.state.timestamp = null;
                    this.update();
                    return;
                }

                console.log(filter);

                // Save the complete filter object for reference
                this.state.lastFilter = JSON.parse(JSON.stringify(filter));

                try {
                    const skillService = await getSkillService();
                    const results = await skillService.get(
                        this.state.pageIndex,
                        this.state.pageLength,
                        "resources",
                        filter
                    );

                    const skills = results.data;

                    this.state.skills = skills;

                    this.state.totalPages = results.pagination.totalPages;
                    this.state.total = results.pagination.total;
                    this.state.timestamp = Date.now();

                    this.state.searching = false;
                    this.state.hasLoaded = true;
                    this.update();
                } catch (error) {
                    console.error('Failed to load skills:', error);
                    this.state.skills = [];
                    this.state.searching = false;
                    this.state.hasLoaded = true;
                    this.update();
                }

            },

            openExportModal() {
                this.$('export-metadata-summary-detail-modal')?._tag.show();
            },

            exportSkillsCSV(includeResources = false) {
                // Build filter object matching the current search + origin state
                // so the CSV reflects what the user is currently looking at.
                const filter = {};
                if (this.state.searchTerm) {
                    filter.displayName = { $icontains: this.state.searchTerm };
                }
                if (this.state.originFilter === 'custom') {
                    filter.origin = 'custom';
                } else if (this.state.originFilter === 'ESCO') {
                    filter.origin = 'ESCO';
                }
                filter.$sort = this.getSort();
                this.tools.exportSkillsCsv(filter, includeResources, true);
            },

            async generatePrintView() {
                if (!this.state.total) {
                    console.warn('No data available to print');
                    return;
                }

                const skillService = await getSkillService();

                const columns = [
                    { header: this.locale.t('skillname'), value: s => htmlToText(s.displayName) },
                    { header: this.locale.t('description'), value: s => htmlToText(s.description) },
                    { header: this.locale.t('origin'), value: s => this.tools?.skillOriginDisplay(s.origin) || '' },
                    { header: this.locale.t('itemcount'), value: s => this.tools.formatNumber(s.resources?.length || 0) }
                ];

                if (this.props.showdates) {
                    columns.push(
                        { header: this.locale.t('tagtable_createddate'), value: s => this.formatDate(s.createdDate) },
                        { header: this.locale.t('tagtable_updateddate'), value: s => this.formatDate(s.updatedDate) }
                    );
                }

                const reportTitle = this.props.reporttitle || this.locale.t('skills');
                const printTitle = await this.tools.buildPageTitle(`${this.locale.t('report')} - ${reportTitle}`);

                await printReport({
                    title: printTitle,
                    total: this.state.total,
                    pageSize: values.maxLimit,
                    columns,
                    strings: printReportStrings(this.locale, this.tools),
                    fetchPage: (page, limit) => skillService.get(
                        page,
                        limit,
                        "resources",
                        this.state.lastFilter,
                        true
                    )
                });
            }

        }
    </script>
</skill-table>